import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import InnerLayout from '@src/App/Components/Core/Layouts/InnerLayout/InnerLayout';
import type { AppState } from '@store/store';
import React from 'react';
import { useSelector } from 'react-redux';

/**
 * NotFound component.
 *
 * @returns {JSX.Element} The JSX element.
 */
function NotFound() {
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).navigation;
    return (
        <InnerLayout title={langStrings.pageNotFound}>
            <span>{langStrings.pageNotFoundDescription}</span>
        </InnerLayout>
    );
}

export default NotFound;
